import { SystemConfigInsert, SystemConfigDelete, SystemConfigUpdate, SystemConfigGetById, SystemConfigGetList, SystemConfigGetPageList } from "@/api/systemconfig/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {    
    // 新增
    SystemConfigInsert(context, payload) {
        return new Promise((resolve, reject) => {
            
            
            SystemConfigInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    SystemConfigUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            SystemConfigUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    SystemConfigGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            SystemConfigGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    SystemConfigGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            SystemConfigGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    SystemConfigGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            SystemConfigGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}